import { route, number , string} from 'react-router-typesafe-routes/dom'

export const ADD_COMPANY_ROUTES = {
  addCompany: route('et/company/:companyId/addCompanyModule', {
    params: { companyId: string().defined() },
  }),
  serverDatabases: route('et/company/:companyId/addCompanyModule/server/:serverId', {
    params: { companyId: string().defined(), serverId: number().defined() },
  }),
}
